import { render } from "./codingView.vue?vue&type=template&id=6a74faa8&scoped=true"
import script from "./codingView.vue?vue&type=script&lang=js"
export * from "./codingView.vue?vue&type=script&lang=js"

import "./codingView.vue?vue&type=style&index=0&id=6a74faa8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a74faa8"]])

export default __exports__